import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector} from "redux-form";
import { existeFecha, callService } from "../tools";
import './gnp-registro-new-movile.css'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Modal from '../generalcomponets/modal-mobile';
import { servicios } from "../properties";

const mensajeLada = "Tu número de teléfono con lada incluida debe ser de 10 dígitos."

const selector = formValueSelector("registro-datos");

const mapState = (state) => {

	let fechaNacimientoDate = "";
	if (state.registro.fechaNacimientoDate == "") {
		fechaNacimientoDate = state.registro.fechaDeNacimientoDate;
	} else {
		fechaNacimientoDate = state.registro.fechaNacimientoDate;
	}

	let dia = "", mes = "", anio = "";
	if (state.registro.fechaNacimientoDate != "") {
		let date = new Date(state.registro.fechaNacimientoDate);
		dia = (date.getDate() < 10) ? "0" + date.getDate() : date.getDate();
		mes = (date.getMonth() + 1 < 10) ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
		anio = date.getFullYear();
    }
	return {
        dataForm: selector(state, "poliza", "motor", "placas", "inicioVigenciaPolizaDate", "certificado", "dia", "mes", "anio", "polizaBanamex", "rfcbnmx", "fechaDeNacimientoDate", "diaNacimiento", "mesNacimiento", "anioNacimiento"),
		ramo: state.registro.ramo,
		grupo: state.registro.configuracion.grupo,
		dispositivo: state.global.dispositivo,
		fechaDeNacimiento: state.registro.fechaDeNacimiento,
		fechaDeNacimientoDate: state.registro.fechaDeNacimientoDate,
		polizaBanamex: state.registro.polizaBanamex,
		rfc: state.registro.rfcbnmx,
		initialValues: {
			email: state.registro.email,
			email_confirm: state.registro.email,
			fechaNacimiento: state.registro.fechaNacimiento,
			fechaNacimientoDate: fechaNacimientoDate,
			lada_fijo: state.registro.ladaFijo,
			telefono_fijo: state.registro.telFijo,
			lada_movil: state.registro.ladaCelular,
			telefono_movil: state.registro.telCelular,
			apaterno: state.registro.apaterno,
			amaterno: state.registro.amaterno,
			nombres: state.registro.nombres,
			dia: dia,
			mes: mes,
			anio: anio
		}
	};
};

const mapDispatch = (dispatch) => {
	return {
		regresar: (disp) => {
			dispatch({ "type": "EVENT_REGISTRO_DP-REGRESAR", "dispositivo": disp });
			dispatch({ "type": "REGISTRO_PASO", "paso": 0 });
        },
        alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje": sMensaje });
        },
        alertaCode: (sCode) => {
			dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo": sCode });
		},
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
	};
};

const telefono = tipo => (value, campos) => {
	let numero = (value != undefined) ? value.replace("+", "").replace(" ", "") : "";
	let prefijo = (/lada/g.test(tipo)) ? "+" : "";

	if (numero != "" && isNaN(numero)) {
		let _temp = "";
		for (let i = 0; i < numero.length; i++) {
			if (!isNaN(numero.substr(i, 1))) {
				_temp += numero.substr(i, 1);
			}
		}
		numero = _temp;
	}

	if (numero != "") {
		campos[tipo] = prefijo + ((/lada/g.test(tipo)) ? numero.substr(0, 3) : numero);
	} else {
		campos[tipo] = "";
	}
};

const espacios = tipo => (value, campos) => {
	let texto = (value != undefined && value != " ") ? value : "";
	texto = texto.replace(/\s{2,}/g, " ");
	campos[tipo] = texto;
};

const onSubmitFail = (errors, dispatch, submitError, props) => {
	if (errors.poliza === "Campo requerido." || errors.dia === "Campo requerido.") {
		dispatch({ "type": "EVENT_REGISTRO_DP-VACIOS", "dispositivo": props.dispositivo });
	} else {
		dispatch({ "type": "EVENT_REGISTRO_DP-INCORRECTOS", "dispositivo": props.dispositivo });
	}
};

const validate = (campos) => {
	const errors = {};

	if (!campos.email) {
		errors.email = "Campo requerido.";
	} else {
		campos.email = campos.email.replace(" ", "");
		console.log(`Validación correo: ${campos.email}`)
		if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(campos.email)) {
			errors.email = "El correo electrónico no es válido. Favor de verificar.";
		}
	}

	if (!campos.email_confirm) {
		errors.email_confirm = "Campo requerido.";
	} else {
		campos.email_confirm = campos.email_confirm.replace(" ", "");
		if (campos.email && campos.email_confirm && (campos.email != campos.email_confirm)) {
			errors.email_confirm = "El correo electrónico no coincide. Favor de verificar.";
		}
	}

	if (!campos.telefono_movil) {
		errors.lada_movil = "Campo requerido.";
	} else if (!campos.lada_movil && campos.telefono_movil) {
		errors.lada_movil = "Campo lada requerido.";
	} else if (campos.lada_movil && campos.telefono_movil && ((campos.lada_movil.length + campos.telefono_movil.length)) !== 10) {
		errors.lada_movil = "Tu número de teléfono con lada incluida debe ser de 10 dígitos.";
	} else if (campos.lada_movil && campos.telefono_movil && campos.lada_fijo && campos.telefono_fijo) {
		let celular = campos.lada_movil + campos.telefono_movil;
		let telefono = campos.lada_fijo + campos.telefono_fijo;
		if (celular == telefono) {
			errors.lada_fijo = "Tu número de teléfono debe ser diferente.";
		}
	}

	if (campos.lada_fijo && !campos.telefono_fijo) {
		errors.lada_fijo = "Campo requerido.";
	} else if (!campos.lada_fijo && campos.telefono_fijo) {
		errors.lada_fijo = "Campo lada fijo requerido.";
	} else if (campos.lada_fijo && campos.telefono_fijo && ((campos.lada_fijo.length + campos.telefono_fijo.length)) !== 10) {
		errors.lada_fijo = "Tu número de teléfono con lada incluida debe ser de 10 dígitos.";
	}

	if (campos.lada_fijo == "+" && campos.telefono_fijo == "") {
		delete errors.lada_fijo;
	} else if (campos.lada_fijo == "+" && !campos.telefono_fijo) {
		delete errors.lada_fijo;
	}

	if (!campos.dia || !campos.mes || !campos.anio) {
		errors.dia = "Campo requerido.";
	} else if (existeFecha(campos.dia, campos.mes, campos.anio) == false) {
		errors.dia = "La fecha introducida es inválida.";
	}

	if (!campos.nombres || campos.nombres.trim() == "") {
		errors.nombres = "Campo requerido.";
	}

	if (!campos.apaterno || campos.apaterno.trim() == "") {
		errors.apaterno = "Campo requerido.";
	}

	if (!campos.amaterno || campos.amaterno.trim() == "") {
		errors.amaterno = "Campo requerido.";
	}

	if (!campos.rfc) {
		errors.rfc = "Campo requerido.";
	} else if (/^[a-zA-Z]{3,4}(\d{6})((\D|\d){2,3})?$/.test(campos.rfc) == false) {
		errors.rfc = "Formato de RFC inválido.";
	} else if (campos.rfc && campos.dia && campos.mes && campos.anio) {
		if (campos.rfc.substr("4", "6") != campos.anio.toString().substr("2", "2") + campos.mes + campos.dia) {
			errors.rfc = "El RFC no concuerda con la fecha de nacimiento.";
		}
	}

	return errors;
};

const campo = ({ ...custom, input, label, max, type, focus, blur, change, meta: { touched, error } }) => {
    return (
        <MuiThemeProvider>
            <TextField
                floatingLabelText={label}
                fullWidth={true}
                underlineStyle={{borderColor: '#AAC3EE'}}
                underlineFocusStyle={{borderColor: '#FF6B0B'}}
                floatingLabelStyle={floatingLabelStyleSettings}
                floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
                type={type}
                onFocus={focus}
				onBlur={(event) => { input.onBlur(event); }}
                onChange={(event) => { console.log(event.target.name);input.onChange(event); change(event); }}
                maxLength={max}
                errorText={touched && error}
            />
        </MuiThemeProvider>
    );
};

const campoSelect = ({
    input,
    label,
    type,
    blur,
    change,
    name,
    meta: { touched, error },
    children,
    ...custom
}) => {
    return (
            <MuiThemeProvider>
                <SelectField
                    {...input}
                    name={name}
                    floatingLabelText={label}
                    underlineStyle={{borderColor: '#AAC3EE'}}
                    underlineFocusStyle={{borderColor: '#FF6B0B'}}
                    floatingLabelStyle={floatingLabelStyleSettings}
                    floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
                    onChange={(event, index, value) => { input.onChange(value); change(event, index, value, name); }}
                    children={children}
                    fullWidth={true}
                    errorText={touched && error}
                    {...custom}
                    />
            </MuiThemeProvider>
    );
};

const campoSettings = {
	fontFamily:'Roboto',
	fontStyle: 'normal',
	fontWeight: 'normal',
	mixBlendMode: 'normal',
}
const floatingLabelStyleSettings={
		...campoSettings,
		lineHeight: '24px',
		letterSpacing: '0.5px',
		color: '#0C2040',
}
const floatingLabelFocusStyleSettings={
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.4px',
	color: '#FF6B0B',
}
class Datos extends React.Component {

	msjaMostrarMovil = "";
	msjaMostrarFijo = "";
	errorsLadaMovil = false;
	errorsFijo = false;

	state = {
        claseFlecha: "",
		isValidTelFijo:false,
		isValidCorreo:false,
		isValidTel:false,
		intentosTelFijo:0,
		intentosTel:0,
		intentosCorreo:0,
        isModalOpened: false,
		openModalValidaciones:false,
		openModalValMensaje:"",
		isEditCorreo:false,
		isEditTelFijo:false,
		isEditTel:false,
		modalMesage:{type: null, message: null}
	}

	openModalValidaciones = (mensaje) => {
		this.setState({
			openModalValMensaje:mensaje,
			openModalValidaciones:true
		});
	}

	closeModalValidaciones = () => {
		this.setState({openModalValidaciones:false});
	}

	componentWillMount = () => {
		console.log("componentWillMount");
	}

	handleScroll = (event) => {
		if (event.currentTarget.scrollTop > 130) {
			this.setState({ claseFlecha: "up" });
		} else if (event.currentTarget.scrollTop > 40) {
			this.setState({ claseFlecha: "left" });
		} else {
			this.setState({ claseFlecha: "" });
		}
	}

    resetConfiguracion = () => {
        this.props.change("fechaDeNacimiento", "");
        this.props.untouch("fechaDeNacimiento");
        this.props.change("dia","");
        this.props.untouch("día");
        this.props.change("mes","");
        this.props.untouch("mes");
        this.props.change("anio","");
        this.props.untouch("anio");
    }

    openModalParent = (type, title, message) => {
		let { isModalOpened } = this.state;

		if(isModalOpened)
		  this.setState({ isModalOpened: false, modalMesage:{ type: null, title: null,  message: null}})
		else{
		  this.setState({ isModalOpened: true, modalMesage:{ type, title, message}});
		}
	}

	closeModalFromChild = () => {
		this.setState({ isModalOpened: false, modalMesage:{ type: null, message: null}})
	}

	handleChangeSelect = (event, index, value, tipo) => {
		if (!this.props.polizaBanamex)
            this.getFechaNacimiento();

    }

	handleChange = (event, index, value, tipo) => {
		if (!this.props.polizaBanamex)
            this.getFechaNacimiento();
	}

	handleChangeTelefono = (event, index, value, tipo) => {
		this.handleChange(event, index, value, tipo);
		this.setState({
			isEditTel:true,
			isValidTel:false,
		});
	}

	handleChangeCorreo = (event, index, value, tipo) => {
		this.handleChange(event, index, value, tipo);
		this.setState({
			isEditCorreo:true,
			isValidCorreo:false
		});
	}

	handleChangeTelefonoFijo = (event, index, value, tipo) => {
		this.handleChange(event, index, value, tipo);
		this.setState({
			isEditTelFijo:true,
			isValidTelFijo:false
		});
	}

	regresar = () => {
		console.log(this.props.dispositivo);
		this.props.regresar(this.props.dispositivo);
	}

	getFechaNacimiento = () => {
        let oForm = this.props.dataForm;
        let dia = this.dia.value;
        let mes = this.mes.value;
        let anio = this.anio.value;

        console.log("fecha día :",dia);
        console.log("mes :",mes);
        console.log("año :",anio);

		if (dia != "" && mes != "" && anio != "") {
			let date = new Date(anio, mes - 1, dia);
			this.props.change("fechaNacimiento", moment(anio + "-" + mes + "-" + dia, "YYYY-MM-DD").format("DD - MMMM - YYYY"));
			this.props.change("fechaNacimientoDate", date.getTime());

			return dia + "/" + mes + "/" + anio;
		} else {
			return false;
		}
	}

	actualizaPersona = (oForm) => {
		let $this = this;
		$this.props.loader(true);

		let llamaServicio = new callService({
			service: "utilerias.actualizaPersona",
			secure: true,
			data: {}
		}).execute().then((oResult) => {
			console.log("Respuesta", oResult);

		}).catch((error) => {
			console.log("Error", error);
		});
	};

	beforeSubmit = (values) => {
		if (!this.props.polizaBanamex)
			this.getFechaNacimiento();
		this.props.onSubmit({...values})
	}

	siguiente = () => {
		if (!this.props.polizaBanamex)
			this.getFechaNacimiento();
		this.props.handleSubmit(values => {this.props.onSubmit({ ...values }); })();
	}

	validarMediosContacto = () => {
		var isBasicValid = false;
		this.props.handleSubmit(values => { isBasicValid = true})();
		if(isBasicValid){
			this.validarCorreo();
		}
	}

	validarCorreo = () => {
		if(!this.state.isValidCorreo){
			if(this.state.isEditCorreo && this.state.intentosCorreo > 1){
				this.setState({
					intentosCorreo:0
				});
			}
			this.setState({
				isEditCorreo:false
			})
			this.llamarNeoRed();
		}else{
			this.validarTelefono();
		}
	}

	validarTelefono = () => {
		if(!this.state.isValidTel){
			if(this.state.isEditTel && this.state.intentosTel > 1){
				this.setState({
					intentosTel:0
				});
			}
			this.setState({
				isEditTel:false
			})
			this.llamarIFTEL();
		}else{
			this.validarTelefonoFijo();
		}
	}

	validarTelefonoFijo = () => {
		if(!(this.lada_fijo.value == "") || !(this.telefono_fijo.value == "")) {

			if(!this.state.isValidTelFijo){
				if(this.state.isEditTelFijo && this.state.intentosTelFijo > 1){
					this.setState({
						intentosTelFijo:0,
					});
				}
				this.setState({
					isEditTelFijo:false
				})
				this.llamarIFTELFijo();
			}else{
				this.siguiente();
			}
		}else {
			this.siguiente();
		}
	}

	llamarNeoRed = () => {
		this.props.loader(true);
		var url = new URL(servicios.utilerias.validadorMediosContacto + '/validador/formato-email'),
			params = {"email":this.email.value}
		Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

		const requestOptions = {
			method: 'GET',
			headers: { 
			'Content-Type': 'application/json',
			'apiKey':servicios.utilerias.apiKeyMC,
			'Access-Control-Allow-Origin':'*'
			},
		};

		fetch(url, requestOptions)
			.then(response => response.json())
			.then(data => {
				this.props.loader(false);
				let intentosCorreo = this.state.intentosCorreo;	
				if(data){
					this.setState({
						isValidCorreo:true
					});
					this.validarTelefono();
				}else{
					if(this.state.intentosCorreo > 1){
						this.setState({
							isValidCorreo:true
						});
						this.validarTelefono();
					}
					else if(this.state.intentosCorreo == 1){
						this.openModalValidaciones("El correo electrónico sigue identificado como inválido. Da clic en aceptar para seguir adelante con el trámite.");
					}else{
						this.openModalValidaciones("El correo electrónico registrado es inválido, por favor intente nuevamente.");
					}
					intentosCorreo++;
					this.setState({intentosCorreo:intentosCorreo});
				}
			}).catch(error =>{
				this.props.loader(false);
				this.setState({
					isValidCorreo:true
				});
				console.log('Servicio NeoRed no disponible');
				this.validarTelefono();
			});
	}

	llamarIFTELFijo = () => {
		this.props.loader(true);
		var url = new URL(servicios.utilerias.validadorMediosContacto + '/validador/formato-telefono'),
			params = {"telefono":(this.lada_fijo.value+this.telefono_fijo.value)}
		Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

		const requestOptions = {
			method: 'GET',
			headers: { 
			'Content-Type': 'application/json',
			'apiKey':servicios.utilerias.apiKeyMC,
			'Access-Control-Allow-Origin':'*'
			},
		};

		fetch(url, requestOptions)
			.then(response => response.json())
			.then(data => {
				this.props.loader(false);
				let intentosTelFijo = this.state.intentosTelFijo;	
				if(data.validacionMedioContacto){
					if(data.tipoMedioContacto == "TLPT"){
						this.setState({
							isValidTelFijo:true
						});
						this.siguiente();
					}else{
						if(this.state.intentosTelFijo > 1){
							this.setState({
								isValidTelFijo:true
							});
							this.siguiente();
						}
						else if(this.state.intentosTelFijo == 1){
							this.openModalValidaciones("El teléfono sigue identificado como número móvil. Da clic en aceptar para seguir adelante con el trámite.");
						}else{
							this.openModalValidaciones("El télefono registrado es un número móvil, por favor intente nuevamente.");
						}
						intentosTelFijo++;
						this.setState({intentosTelFijo:intentosTelFijo});
					}	
				}else{
					if(this.state.intentosTelFijo > 1){
						this.siguiente();
					}
					else if(this.state.intentosTelFijo == 1){
						this.openModalValidaciones("El teléfono fijo sigue identificado como inválido. Da clic en aceptar para seguir adelante con el trámite.");
					}else{
						this.openModalValidaciones("El teléfono fijo registrado es inválido, por favor intente nuevamente.");
					}
					intentosTelFijo++;
					this.setState({intentosTelFijo:intentosTelFijo});
				}
			}).catch(error =>{
				this.props.loader(false);
				this.setState({
					isValidTelFijo:true
				});
				console.log('Servicio iftel no disponible');
				this.siguiente();
			});
	}

	llamarIFTEL = () => {
		this.props.loader(true);
		var url = new URL(servicios.utilerias.validadorMediosContacto + '/validador/formato-telefono'),
			params = {"telefono":(this.lada_movil.value+this.telefono_movil.value)}
		Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

		const requestOptions = {
			method: 'GET',
			headers: { 
			'Content-Type': 'application/json',
			'apiKey':servicios.utilerias.apiKeyMC,
			'Access-Control-Allow-Origin':'*'
			},
		};

		fetch(url, requestOptions)
			.then(response => response.json())
			.then(data => {
				this.props.loader(false);
				let intentosTel = this.state.intentosTel;	
				if(data.validacionMedioContacto){
					if(data.tipoMedioContacto == "TLCL"){
						this.setState({
							isValidTel:true
						});
						this.validarTelefonoFijo();
					}else{
						if(this.state.intentosTel > 1){
							this.setState({
								isValidTel:true
							});
							this.validarTelefonoFijo();
						}
						else if(this.state.intentosTel == 1){
							this.openModalValidaciones("El teléfono sigue identificado como número fijo. Da clic en aceptar para seguir adelante con el trámite.");
						}else{
							this.openModalValidaciones("El télefono registrado es un número fijo, por favor intente nuevamente.");
						}
						intentosTel++;
						this.setState({intentosTel:intentosTel});
					}	
				}else{
					if(this.state.intentosTel > 1){
						this.validarTelefonoFijo();
					}
					else if(this.state.intentosTel == 1){
						this.openModalValidaciones("El teléfono móvil sigue identificado como inválido. Da clic en aceptar para seguir adelante con el trámite.");
					}else{
						this.openModalValidaciones("El teléfono móvil registrado es inválido, por favor intente nuevamente.");
					}
					intentosTel++;
					this.setState({intentosTel:intentosTel});
				}
			}).catch(error =>{
				this.props.loader(false);
				this.setState({
					isValidTel:true
				});
				console.log('Servicio iftel no disponible');
				this.validarTelefonoFijo();
			});
	}

	handleBlurLadaMovil = campos => {

		if(campos === undefined || campos.lada_movil === undefined || campos.telefono_movil === undefined) {
			console.log("");
		}else
		if( (campos.lada_movil.length + campos.telefono_movil.length) !== 10 ){
			console.log(campos.lada_movil);
			console.log("1");

			this.errorsLadaMovil = true;
			return this.msjaMostrarMovil = mensajeLada;	
		}else{
			console.log("2");
			this.errorsLadaMovil = false;
			return this.msjaMostrarMovil = "";	
		}
	}

	handleBlurLadaFijo = campos => {

		if(campos === undefined || campos.lada_fijo === undefined || campos.telefono_fijo === undefined) {
			console.log("");
		}else
		if( (campos.lada_fijo.length + campos.telefono_fijo.length) !== 10 ){
			this.errorsFijo = true;
			return this.msjaMostrarFijo = mensajeLada;	
		}else{
			this.errorsFijo = false;
			return this.msjaMostrarFijo = "";	
		}
	}

	render() {
		const { handleSubmit, submitting } = this.props;

		var dias = [], meses = [], anios = [];
		for (let i = 1; i <= 31; i++) {
			let dia = (i < 10) ? "0" + i : i;
            dias.push(<MenuItem value={dia} key={i} primaryText={dia} />);
			if (i <= 12) {
                meses.push(<MenuItem value={dia} key={i} primaryText={dia} />)
			}
		}
        for (let i = new Date().getFullYear(); i >= 1920; i--) {
            anios.push(<MenuItem value={i} key={i} primaryText={i} />)
        }
        return (
			<form  onSubmit={handleSubmit(this.beforeSubmit)} className="remove-all-styles">
				<div className="container" >
					<div className="margin-mobile">
						<div className="row">
							{this.props.polizaBanamex == false &&
								<div className="">
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <label className="gnp-material-label margin-labels">Fecha de nacimiento*</label>
                                    </div>
									<div className="col-md-4 col-sm-4 col-xs-4 select-field-left">
										<Field ref={elem => this.dia = elem} label="día"  name="dia"  component={campoSelect} change={this.handleChangeSelect.bind(this)}>
											{dias}
										</Field>
									</div>
									<div className="col-md-4 col-sm-4 col-xs-4 select-field-center">
										<Field ref={elem => this.mes = elem}name="mes" label="mes" component={campoSelect} change={this.handleChangeSelect.bind(this)}>
											{meses}
										</Field>
									</div>
									<div className="col-md-4 col-sm-4 col-xs-4 select-field-right">
										<Field ref={elem => this.anio = elem} name="anio" label="año" component={campoSelect} change={this.handleChangeSelect.bind(this)} >
											{anios}
										</Field>
									</div>
                                 </div>
								}
						</div>

						{this.props.polizaBanamex &&
							<div className="row">
								<div className="col-md-8 col-sm-6 col-xs-12">
									<div className="">
											<MuiThemeProvider>
												<TextField
													disabled={true}
													floatingLabelText="Fecha de nacimiento"
													fullWidth={true}
													underlineStyle={{borderColor: '#AAC3EE'}}
													underlineFocusStyle={{borderColor: '#FF6B0B'}}
													floatingLabelStyle={floatingLabelStyleSettings}
													floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
													value={this.props.fechaDeNacimiento}
													onChange={this.handleChange.bind(this)}
												/>
											</MuiThemeProvider>
									</div>
									<div className="">
											<MuiThemeProvider>
												<TextField
													disabled={true}
													floatingLabelText="RFC"
													fullWidth={true}
													underlineStyle={{borderColor: '#AAC3EE'}}
													underlineFocusStyle={{borderColor: '#FF6B0B'}}
													floatingLabelStyle={floatingLabelStyleSettings}
													floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
													value={this.props.rfc}
													onChange={this.handleChange.bind(this)}
												/>
											</MuiThemeProvider>
									</div>
								</div>
							</div>}

						<div className="row">
							<div className="col-md-6 col-sm-6 col-xs-12 ">
								<Field ref={elem => this.email = elem} name="email" change={this.handleChangeCorreo.bind(this)} component={campo} type="text" label="Correo electrónico *" max="50" 
									// validate={espacios("email")}  
								/>
							</div>

						    <div className="col-md-6 col-sm-6 col-xs-12 ">
								<Field name="email_confirm"  change={this.handleChange.bind(this)}  component={campo} type="text" label="Confirmar correo electrónico*" max="50" 
									// validate={espacios("email_confirm")} 
								/>
                            </div>
						</div>
						<div className="row">
							<div className="col-md-6 col-sm-6 col-xs-12">
								<div className="row">
									<div className="col-xs-4">
										<Field  name="lada_movil" ref={elem => this.lada_movil = elem} change={this.handleChangeTelefono.bind(this)} component={campo} type="text" max="3" label="LADA*" 
											onBlur={this.handleBlurLadaMovil.bind(this)} error={this.errorsLadaMovil ? this.msjaMostrarMovil : null} // validate={telefono("lada_movil")} 
										/>
										<img src={ require("../img/help_outline_24px.png") }  onClick={this.openModalParent} />
									</div>
									<div className="col-xs-8">
										<Field  name="telefono_movil" ref={elem => this.telefono_movil = elem} change={this.handleChangeTelefono.bind(this)} component={campo} type="text" max="8" label="Teléfono*" 
											onBlur={this.handleBlurLadaMovil.bind(this)} // validate={telefono("telefono_movil")} 
										/>
									</div>
								</div>
							</div>

							<div className="col-md-6 col-sm-6 col-xs-12">
								<div className="row">
									<div className="col-xs-4 ">
										<Field  name="lada_fijo" ref={elem => this.lada_fijo = elem} change={this.handleChangeTelefonoFijo.bind(this)} component={campo} type="text" max="3" label="LADA" 
											onBlur={this.handleBlurLadaFijo.bind(this)} error={this.errorsFijo ? this.msjaMostrarFijo : null} // validate={telefono("lada_fijo")} 
										/>
									</div>
									<div className="col-xs-8 ">
										<Field  name="telefono_fijo" ref={elem => this.telefono_fijo = elem} change={this.handleChangeTelefonoFijo.bind(this)} component={campo} type="text" max="8" label="Teléfono fijo" 
											onBlur={this.handleBlurLadaFijo.bind(this)} // validate={telefono("telefono_fijo")} 
										/>
									</div>
								</div>
							</div>
						</div>

						{this.props.grupo && this.props.ramo == "A" &&
							<div className="row">
								<div className="col-md-4 col-sm-4 col-xs-12">
									<Field name="apaterno" label="Apellido Paterno"  change={this.handleChange.bind(this)}  component={campo} type="text" 
										// validate={espacios("apaterno")} 
									/>
								</div>
								<div className="col-md-4 col-sm-4 col-xs-12">
									<Field name="amaterno" label="Apellido Materno"  change={this.handleChange.bind(this)}  component={campo} type="text" 
										// validate={espacios("amaterno")} 
									/>
								</div>
								<div className="col-md-4 col-sm-4 col-xs-12">
									<Field name="nombres" label="Nombre(s)"  change={this.handleChange.bind(this)} component={campo} type="text" 
										// validate={espacios("nombres")} 
									/>
								</div>
							</div>
						}
						{this.props.grupo && this.props.ramo == "V" &&
							<div className="row">
								<div className="col-md-6 col-sm-6 col-xs-12">
                                    <Field name="rfc" label="RFC*" type="text" max="13"change={this.handleChange.bind(this)} component={campo} />
								</div>
							</div>
						}
						<p className="txt-obligatorio txt-obligatorio-movil"><span>*</span> Campos Obligatorios</p>
					</div>
					<Field name="fechaNacimiento" component="input" type="hidden" />
					<Field name="fechaNacimientoDate" component="input" type="hidden" />
				</div>

				{/* <div className="row"> */}
					<div className="registro-button-container">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <button type="button" disabled={submitting} onClick={this.validarMediosContacto} className="pure-material-button-contained btn-full-width">Continuar</button>
                            </div>
					</div>
				{/* </div> */}
                {this.state.isModalOpened &&
                    <Modal closeModalFromChild={this.closeModalFromChild} >
						<div className="conteiner">
                            <div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
									<label className="gnp-material-title-modal-titulo-M">Establecer teléfono de contacto</label>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
									<p className=" gnp-material-content-modal-body-M">El teléfono celular será utilizado como medio de contacto para notificarte operaciones realizadas o enviarte códigos de verificación requeridos en algunas transacciones.</p>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom">
									<button type="button" onClick={this.closeModalFromChild} className="pure-material-button-contained btn-full-width">Aceptar</button>
							</div>
						</div>

                    </Modal>}
				
					{this.state.openModalValidaciones &&
                    <Modal >
						<div className="conteiner">
                            <div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
									<label className="gnp-material-title-modal-titulo-M">ERROR</label>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
									<p className=" gnp-material-content-modal-body-M">{this.state.openModalValMensaje}</p>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom">
									<button type="button" onClick={this.closeModalValidaciones} className="pure-material-button-contained btn-full-width">Aceptar</button>
							</div>
						</div>
                    </Modal>}
				
			</form>
		);
	}
}

Datos = reduxForm({ form: "registro-datos", validate, onSubmitFail })(Datos);

export default connect(mapState, mapDispatch)(Datos);



// WEBPACK FOOTER //
// ./src/gnp-registro/datosWebMovil.frm.js